/**
 * Get the named keys of an emum only.
 * @returns An array of enum keys.
 */
export const getEnumKeys = <T extends object>(enumObj: T): (keyof T)[] =>
  Object.keys(enumObj).filter((key) => isNaN(Number(key))) as (keyof T)[];
